module.exports = __webpack_public_path__ + "img/4.dc8b25e9.png";